import { render, staticRenderFns } from "./vancol.vue?vue&type=template&id=2bb45c72&scoped=true&"
import script from "./vancol.vue?vue&type=script&lang=js&"
export * from "./vancol.vue?vue&type=script&lang=js&"
import style0 from "./vancol.vue?vue&type=style&index=0&id=2bb45c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb45c72",
  null
  
)

export default component.exports